import styled from 'styled-components';

export const SecurityTabStyle = styled.div`
  position: relative;
  font-size: 15px;
  line-height: 1.55;
  color: var(--ink);

  .title {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
    margin: 0 0 6px;
    color: var(--ink);
  }

  .text {
    display: block;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    color: var(--mute);
  }

  .info-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .btn {
      width: 100%;
      margin: 0;
      padding: 18px 44px 18px 20px;
      position: relative;
      text-align: left;
      background: var(--white);
      border: 1px solid var(--line);
      border-radius: var(--r-lg);
      box-shadow: var(--shadow-soft);
      transition: border-color 0.2s var(--ease);

      &:hover {
        border-color: rgba(21, 20, 15, 0.2);
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      font-size: 22px;
      line-height: 1;
      color: var(--mute);
    }
  }
`;
